import { db } from '@/firebaseApp'

export enum AccessCodesStates {
  Ok = 'ok',
  NotYetValid = 'notyetvalid',
  Expired = 'expired',
  Unknown = 'unknown',
}

class AccessCodes {
  generate() {
    const charCodeA = 'A'.charCodeAt(0)
    const chars = []
    for (let i = 0; i < 12; i++) {
      if (i > 0 && i % 4 == 0) {
        chars.push('-')
      }
      const charCode = charCodeA + Math.floor(Math.random() * 26)
      chars.push(String.fromCharCode(charCode))
    }

    const accessCode = chars.join('')
    return accessCode
  }

  async check(restaurantId: string, code: string) {
    try {
      const snapshot = await db.ref(`restaurants/${restaurantId}/seatings/${code}`).once('value')
      const codeObject = snapshot.val()

      if (!codeObject) {
        return AccessCodesStates.Unknown
      }

      const now = Date.now()
      const validFrom = codeObject.validFrom
      const expiresOn = codeObject.expiresOn

      if (now < validFrom) {
        return AccessCodesStates.NotYetValid
      } else if (now > expiresOn) {
        return AccessCodesStates.Expired
      }

      return AccessCodesStates.Ok
    } catch(err) {
      console.error(err)
      return AccessCodesStates.Unknown
    }
  }
}

export default new AccessCodes()
